import reducer from './reducer'
export default reducer



// WEBPACK FOOTER //
// ./src/reducers/index.js